'use es6';

import http from 'hub-http/clients/apiClient';
import { getTicketPropertiesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
import { ER_TICKET_PROPERTIES_ALIAS } from 'FormsCommonComponents/earlyRequest/earlyRequestKeys';
const BASE_PATH = 'properties/v4';
function _getTicketPropertiesGroups() {
  return http.get(`${BASE_PATH}/groups/ticket/with-statistics`).then(({
    results
  }) => results);
}
export function getTicketPropertiesGroups() {
  return getFromEarlyRequest(getTicketPropertiesKey(), () => _getTicketPropertiesGroups(), {
    alias: ER_TICKET_PROPERTIES_ALIAS
  });
}